import { render, staticRenderFns } from "./mallGoodsChannel.vue?vue&type=template&id=347d529f&scoped=true&"
import script from "./mallGoodsChannel.vue?vue&type=script&lang=js&"
export * from "./mallGoodsChannel.vue?vue&type=script&lang=js&"
import style0 from "./mallGoodsChannel.vue?vue&type=style&index=0&id=347d529f&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347d529f",
  null
  
)

export default component.exports